import axios from 'axios';
import { SERVICE_STATUS } from './constants';
import { FETCH_METHOD, isCancel } from './request';

/**
 * 不做弹窗提示的请求
 */
const request = axios.create();
request.interceptors.response.use(
  (response) => {
    // 比斯特GWC状态码 200000请求成功
    if (response.data.status !== SERVICE_STATUS.SUCCESS) {
      throw response;
    }
    return response;
  }
);

const generateFetchFunction =
  (method: FETCH_METHOD) =>
    (url: string, options?: any): Promise<any> =>
      request(url, {
        ...options,
        method,
      }).catch((error: any) => {
        // cancel 的请求不需要报错
        if (isCancel(error)) {
          return null;
        }
        return Promise.reject(error);
      });

export const fetchGET = generateFetchFunction(FETCH_METHOD.GET);
export const fetchPOST = generateFetchFunction(FETCH_METHOD.POST);
export const fetchPATCH = generateFetchFunction(FETCH_METHOD.PATCH);
export const fetchPUT = generateFetchFunction(FETCH_METHOD.PUT);
export const fetchDELETE = generateFetchFunction(FETCH_METHOD.DELETE);
